import { min } from 'd3-array';

export const getMinOrZero = (data: any[], valueKey: string) => {
  if (!data.length) return 0;

  const minValue = min(data, d => +d[valueKey])!;
  const minOrZero = Math.max(minValue, 0)
  return minOrZero;
}